"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisuallyHidden = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var root_1 = require("./styled/root");
var VisuallyHidden = function (_a) {
    var className = _a.className, children = _a.children, id = _a.id, _b = _a.as, as = _b === void 0 ? 'span' : _b, testID = _a["data-testid"];
    var Comp = as;
    return (react_1.default.createElement(Comp, { style: root_1.rootStyles, className: className, id: id, "data-testid": testID }, children));
};
exports.VisuallyHidden = VisuallyHidden;
//# sourceMappingURL=visually-hidden.js.map